import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Update = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 8v4c0 .27.11.52.29.71l2.79 2.79a.996.996 0 101.41-1.41l-2.5-2.5V8c0-.55-.45-1-1-1A1 1 0 0011 8zm9.15-3.15l-1.31 1.31A8.963 8.963 0 0012.24 3C7.35 2.88 3.14 6.86 3 11.74a9.003 9.003 0 0017.72 2.5c.16-.63-.33-1.24-.98-1.24-.45 0-.85.3-.96.73a7.014 7.014 0 01-8.05 5.16c-2.78-.49-5.04-2.71-5.58-5.47C4.26 8.94 7.68 5 12 5c2.18 0 4.12 1.02 5.41 2.59l-1.55 1.55c-.32.32-.1.86.35.86h4.29c.28 0 .5-.22.5-.5V5.21a.5.5 0 00-.85-.36z"
  }));
});
Update.displayName = 'Update';
export var UpdateDimensions = {
  height: 24,
  width: 24
};